import type { TranslationKey } from "@privacy/translations";
import type { AssistantConversationRecord } from "../../api/assistant";
import { PARTNER_FORM_TYPE, SYSTEM_FORM_TYPE } from "../../api/assistant";

const COUNT_KEYS: Record<string, { one: TranslationKey; other: TranslationKey }> = {
  [SYSTEM_FORM_TYPE]: { one: "Assistant.Count.SystemOne", other: "Assistant.Count.SystemOther" },
  [PARTNER_FORM_TYPE]: { one: "Assistant.Count.PartnerOne", other: "Assistant.Count.PartnerOther" },
};

const REGISTRATION_COUNT_KEYS = {
  one: "Assistant.Count.RegistrationOne",
  other: "Assistant.Count.RegistrationOther",
} as const;

export type RecordKind = { formType: string; count: number };

export const recordKinds = (records: Array<AssistantConversationRecord> | null | undefined): Array<RecordKind> => {
  const kinds: Array<RecordKind> = [];
  for (const record of records ?? []) {
    const kind = kinds.find(candidate => candidate.formType === record.formType);
    if (kind) kind.count += 1;
    else kinds.push({ formType: record.formType, count: 1 });
  }
  return kinds;
};

export const recordCountKey = (kind: RecordKind): TranslationKey => {
  const keys = COUNT_KEYS[kind.formType] ?? REGISTRATION_COUNT_KEYS;
  return kind.count === 1 ? keys.one : keys.other;
};

export const dayGroup = (isoDate: string, now = new Date()): "today" | "yesterday" | "earlier" => {
  const date = new Date(isoDate);
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfToday.getDate() - 1);
  if (date >= startOfToday) return "today";
  if (date >= startOfYesterday) return "yesterday";
  return "earlier";
};
